import { StoreSchema } from '../../../../shared/config/storeConfig/StoreSchema'

export const selectEditableProduct = (state: StoreSchema) =>
    state.product.editableProduct
